module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.NonProfitOrganizationDetails),
      expression: "FormInputs.NonProfitOrganizationDetails"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-sm-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Non-Profit Organization Details\n    ")]), _vm._v(" "), _c('p', [_vm._v("Please answer the following questions about your non-profit organization.")]), _vm._v(" "), _c('p', {
    staticClass: "nonProfit_order"
  }, [_vm._v("Are you considered a Covered Entity under HIPAA classifications?*\n        "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ({
        html: 'tooltipContent',
        class: 'custom-tooltip'
      }),
      expression: "{ html: 'tooltipContent', class: 'custom-tooltip' }",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tooltipContent"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hipaaTooltip)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "IsCoveredUnderHIPAA"
    },
    on: {
      "click": function($event) {
        _vm.Account.IsCoveredUnderHIPAA = true
      }
    }
  }), _vm._v(" Yes\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "IsCoveredUnderHIPAA"
    },
    on: {
      "click": function($event) {
        _vm.Account.IsCoveredUnderHIPAA = false
      }
    }
  }), _vm._v(" No\n        ")])]), _vm._v(" "), (_vm.AccountValidationResult.AccountIsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountIsCoveredUnderHIPAA))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "nonProfit_order"
  }, [_vm._v("Do you, as the non-profit organization, plan to enter orders for glasses, or do you refer cases to eye doctors who order and dispense glasses independently?*")]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.OrderPlan),
      expression: "Account.OrderPlan"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "OrderPlan"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.OrderPlan, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Account, "OrderPlan", "1")
      }
    }
  }), _vm._v(" Non-Profit places orders for glasses\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio g-px-20"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.OrderPlan),
      expression: "Account.OrderPlan"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "OrderPlan"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.OrderPlan, "2")
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "OrderPlan", "2")
      }
    }
  }), _vm._v(" Eye Doctors place orders for glasses\n        ")])]), _vm._v(" "), (_vm.AccountValidationResult.AccountOrderPlan) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.AccountValidationResult.AccountOrderPlan))]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md g-mt-100"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-30 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Confirm")])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }, [_vm._v("\n                                    The non-profit may not need to register for an account. Eye doctors that are part of referral \n                                    networks should register for their own accounts.\n                                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-286086f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286086f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/NonProfitOrganizationDetails.vue
// module id = 493
// module chunks = 4